<template>
    <section class="reg-temp-content-area main-content-height p-5">

     <!-- <router-link  :to="{ name: 'SuperadminResellers', query: $route.query }" class="mb-3 inline-block"><i class="fas fa-long-arrow-alt-left"></i> Back</router-link> -->

      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 mb-2 mt-2">
          <h2 class="mb-4" v-if="$route.query.heading">{{ $route.query.heading }} <span class="font-light">Products</span></h2>
          <div class="row">

            <div class="col-sm-12 col-md-12 col-lg-12">
              <input class="search-input top-search-input" v-model="s" placeholder="Search by Model / Serial Number"/>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12">
              <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
            </div>

            <div class="text-center col-sm-12 col-md-12" v-if="loading">
              <loading/>
            </div>
  
            <div class="text-center col-sm-12 col-md-12" v-if="!loading && (loadCount == 1)">
             <p>No Product found.</p>
            </div>
            
            <div v-if="!loading" class="col-sm-12 col-md-6 col-lg-4 col-xl-3" v-bind:key="'product_'+ index" v-for="(product, index) in filtered_registered_products">
              <productItem :type="'superadmin'" :editcallback="editCallBack" :deletecallback="deleteCallBack" :product="product" />
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12">
              <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
            </div>

          </div>
        </div>
      </div>
  
      <!-- <loading v-if="loading"/>
      <template v-else>

      <vue-good-table
        :columns="columns"
        :search-options="{
          enabled: false
        }"
      :rows="registered_products">
        <template slot="table-row" slot-scope="props" >

          <span v-if="props.column.field == 'action'" class="table-action-wrapper">   
            <router-link :to="{ name: 'SuperadminRegisteredProductEdit', params: { id: props.row.id }}" class="see-detail"><i aria-hidden="true" class="fa fa-edit"></i></router-link>
            <a href="#" @click.prevent="deleteThis(props.row)" class="delete-action"><i aria-hidden="true" class="fa fa-trash"></i></a>
             <a v-else-if="active_ticket == 'active'" href="#" @click.prevent="updateTicketStatus(props.row.id, props.row.has_open_ticket)" class="delete-action">revoke</a>
            <a v-else-if="active_ticket == 'requested'" href="#" @click.prevent="updateTicketStatus(props.row.id, props.row.has_open_ticket)" class="delete-action">approve</a>
          </span>
        
          <span v-else-if="props.column.field == 'sku_with_serial_number'">
            <router-link :to="{ name: 'SuperadminRegisteredProductEdit', params: { id: props.row.id }}" class="see-detail">{{ props.row.sku_with_serial_number }}</router-link>
          </span>

           <span v-else-if="props.column.field == 'claim_date'">
              <router-link v-if="props.row.latestTicket" :to="{ name: 'SuperadminRegisteredProductEdit', params: { id: props.row.id }, query: { redirect: 'SuperadminRegisteredproducts', ticket: active_ticket }}" class="see-detail">{{ readAbleTime(props.row.latestTicket.created_at) }}</router-link>
          </span>

          <span v-else-if="props.column.field == 'customer_name'">
            <router-link v-if="props.row.customer" :to="{ name: 'SuperadminCustomersEdit', params: { id: props.row.customer.id }, query: { redirect: 'SuperadminRegisteredProducts', ticket: active_ticket }}" class="see-detail">{{ props.row.customer.fname }}</router-link>
          </span>

        </template>
      </vue-good-table>  
      
      </template> -->
      


    </section>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/helpers/index';
import * as _ from 'lodash';
import moment from 'moment';

export default {
  name: 'registerProductList',
  components: {
    Pagination,
  },
  data(){
    return {
      loading: false,
      s: '',
      userid: '',
      useremail: '',
      pdfdata: '',
      currentPage: 1,
      pageNavs: [],
      filtered_registered_products: [],
      hasActiveFilter: false,
      loadCount: 0,

      // columns: [
      //   {
      //     label: 'S.N',
      //     field: 'sku_with_serial_number',
      //     width: '200px',
      //   },
      //   {
      //     label: 'Model',
      //     field: 'product_model',
      //   },
       
      //   {
      //     label: 'Action',
      //     field: 'action',
      //     width: '100px',
      //   },
      // ],

      // columns_active_warranty: [
      //   {
      //     label: 'S.N',
      //     field: 'sku_with_serial_number',
      //     width: '200px',
      //   },
      //   {
      //     label: 'Model',
      //     field: 'product_model',
      //   },
      //   {
      //     label: 'Claim date',
      //     field: 'claim_date',
      //   },
      //   {
      //     label: 'Customer',
      //     field: 'customer_name',
      //   },
      //   {
      //     label: 'Action',
      //     field: 'action',
      //     width: '150px',
      //   },
      // ],
      // product_list: [],
    };
  },
  created() {
  },
  computed: {
    ...mapGetters({
      vg_loggedIn_user_id: "auth/userid",
    }),
    registered_products() {
      return this.filtered_registered_products;
    },
  },
  watch: {
    's'(val) {
      this.buildQueryAndSearch(1);
    },
  },
  mounted() {
    this.userid = this.$route.params.userid;
    this.useremail = this.$route.query.useremail;
    this.buildQueryAndSearch(1);
  },
  methods: {
    /**
     * Build query and search
     */
    buildQueryAndSearch: _.debounce( function (page = 1) {
      this.currentPage = page;
      let queryObj = {}
    
      // then user id 
        queryObj['userid'] =  this.$route.params.userid;
    
      // then search text
      if(this.s){
        queryObj['s'] =  this.s;
      }
      if(_.isEmpty(queryObj)){
        this.hasActiveFilter = false;
      } else {
        this.hasActiveFilter = true;
      }
      let urlquery = Helpers.buildQueryStringFromObj(queryObj);
      this.fetchRegProducts('&'+urlquery)
    }, 500),


    async fetchRegProductsMain (urlquery) {
      const url = `${Env.baseUrl}/superadmin/reg-product/all?page=${this.currentPage + urlquery}`;
      return await AuthApis.getApi(url).then( (res) => {
        this.loadCount = 1;
        this.filtered_registered_products = res.data.payload;
        this.pageNavs= res.data.nav;
      }).catch(err => {
        console.log(err)
      })
    },

    async fetchRegProducts(urlquery){
      this.loading = true;
      await this.fetchRegProductsMain(urlquery);
      this.loading = false;
    },
    
    /**
     * Fetch page data
     */
    fetchPage(pageNo){
      this.currentPage = pageNo;
      this.buildQueryAndSearch(this.currentPage);
    },

    viewCocCertificate(obj){
      this.va_pdfModal(true);
      this.va_pdfModalObj(obj)
    },
    /**
     * Delete record
     */
    deleteCallBack(product) {
      this.$confirm(
        {
          title: `DELETE?`,
          message: 'Are you sure you want to delete ' + product.sku_with_serial_number ,
          button: {
            no: 'No',
            yes: 'Yes'
          },
          callback: confirm => {
            if (confirm) {
              const url = `${Env.baseUrl}/superadmin/reg-product/delete/${product.id}`;
              AuthApis.deleteApi(url).then(async (res) => {
                this.buildQueryAndSearch(this.currentPage);
                this.$toasted.global.success({
                  message: 'Successfully deleted.'
                })
              }).catch(err => {
                this.$toasted.global.error({
                  message: 'Failed, please try again later.'
                })
              })
            }
          }
        }
      )
    },

    editCallBack(product) {
      this.$router.push({
        name: 'SuperadminRegisteredProductEdit', 
        params: { 
          id: product.id 
        }
      })
    },

     /**
     * Update ticket status
     */
    updateTicketStatus(pid, sts) {
      this.spinner(true);
      const url = `${Env.baseUrl}/superadmin/reg-product/update-ticket-status/${pid}`;
      AuthApis.postApi(url, {
        open_ticket: this.active_ticket == 'active' ? 0 :  1,
      }).then(res => {
        this.spinner(false);
        this.$toasted.global.success({
          message: 'Successfully ' + this.active_ticket ? ' revoked.' :  ' activated.'
        })
        this.buildQueryAndSearch(this.currentPage);
      }).catch(err => {
        this.spinner(false);
        console.log(err)
        this.$toasted.global.error({
          message: 'Failed, please try again later.'
        })
      })
    },

    readAbleTime(str) {
      if(str == '' || str == undefined){
        return '';
      }
      return  moment(str).format("YYYY-MM-DD hh:mm a");
    },

    ...mapActions({
      va_pdfModal: "pdf/setActive",
      va_pdfModalObj: "pdf/setActiveObj",
    }),
  
  }
};
</script>